import { ProgressBar } from '@appsumo/dorado-react';
import { Fragment } from 'react';

import { DealReview } from '~/types/deal';

function BreakoutRating({ dealReview }: { dealReview: DealReview }) {
  const totalReviews = dealReview.review_count;

  const individualRatingCounts: number[] = [
    dealReview.review_count_5_tacos || 0,
    dealReview.review_count_4_tacos || 0,
    dealReview.review_count_3_tacos || 0,
    dealReview.review_count_2_tacos || 0,
    dealReview.review_count_1_tacos || 0,
  ];

  return (
    <div className="mt-6 rounded border border-gravel p-4">
      <h4 className="text-xl font-semibold">Taco ratings</h4>

      <div className="mt-4 grid grid-cols-breakout-ratings items-center gap-x-4 gap-y-5">
        {individualRatingCounts.map((rating, index) => {
          return (
            <Fragment key={`taco-rating-${index}`}>
              <span>{5 - index} tacos</span>
              <ProgressBar
                max={100}
                value={(rating / totalReviews) * 100}
                variant="primary"
                className="h-4 rounded"
              />
              <strong>{Intl.NumberFormat().format(rating)}</strong>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}

export default BreakoutRating;
